import { createAction } from '@reduxjs/toolkit';

interface IBookSetCountPayload {
  payload: {
    count: number,
  }
}

interface IBookUpdateStatePayload {
  payload: {
    count?: number,
    currentPage: number,
    visiblePages: Array<number>,
  }
}

export const setCount = createAction('FLIPBOOK/SET_CHILDREN_COUNT', (count: number): IBookSetCountPayload => ({
  payload: {
    count,
  },
}));

export const updateState = createAction(
  'FLIPBOOK/UPDATE_STATE',
  (currentPage: number, visiblePages: Array<number>, count: number | undefined = undefined): IBookUpdateStatePayload => {
    const result: IBookUpdateStatePayload = {
      payload: {
        currentPage,
        visiblePages: [...visiblePages],
      },
    };
    if (count) {
      result.payload.count = count;
    }
    return result;
  },
);
